function bundleLog(type, event, ...content) {
  const KEY = "123123";
  const prefix = event ? `${KEY} ${event}` : KEY;
  if (type === "warning") {
    console.warn(prefix, ...content);
  } else if (type === "error") {
    console.error(prefix, ...content);
  } else {
    console.log(prefix, ...content);
  }
}

class ProductsBundleCustom extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.contentContainer = this.querySelector(".bundle-test__content");
    this.footerContainer = this.querySelector(".bundle-test__footer");
    this.addToCartBtn = this.querySelector(".bundle-add-to-cart");
    this.totalContainer = this.querySelector(".bundle-test__total");
    this.sharedTooltipEl = null;
    this.activeTooltipTrigger = null;
    this._onTooltipDocumentClick = null;
    this._onTooltipViewportChange = null;
  }
  connectedCallback() {
    this.bundleCollections = window.bundleCollectionsData || [];
    this.bundleInfo = window.bundleInfoData || {};
    this.currentProductHandle = this.getCurrentProductHandle();

    if (!this.contentContainer || !this.footerContainer) {
      bundleLog("error", "[init]", "❌ Container elements not found");
      return;
    }

    this.collectionStates = {};

    this.initVariantPopup();
    this.initSharedTooltip();
    this.renderBundleItems();
  }

  getCurrentProductHandle() {
    const path = window.location.pathname;
    const match = path.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  sortProductsCurrentFirst(products) {
    if (!this.currentProductHandle || !products || !products.length) return products;
    return [...products].sort((a, b) => {
      const aHandle = a.handle || (a.url || "").split("/").pop();
      const bHandle = b.handle || (b.url || "").split("/").pop();
      if (aHandle === this.currentProductHandle) return -1;
      if (bHandle === this.currentProductHandle) return 1;
      return 0;
    });
  }

  renderBundleItems() {
    const hasCollections = this.bundleCollections && this.bundleCollections.length > 0;

    if (!hasCollections) {
      this.style.display = "none";
      return;
    }

    this.style.display = "block";

    let headerHtml = "";
    if (this.bundleInfo && this.bundleInfo.title) {
      headerHtml += `<h3 class="bundle-header-title text-center">${this.bundleInfo.title}</h3>`;
      if (this.bundleInfo.description) {
        headerHtml += `<p class="bundle-header-desc text-center">${this.bundleInfo.description}</p>`;
      }
      if (this.bundleInfo.discount && Array.isArray(this.bundleInfo.discount) && this.bundleInfo.discount.length > 0) {
        headerHtml += `<div class="bundle-discount-badges text-center">`;
        this.bundleInfo.discount.forEach((discount) => {
          if (!discount || discount.value <= 0) return;
          const discountTypeSymbol = (discount.type || discount.discountType || "").toLowerCase() === "percentage" ? "%" : "$";
          const dVal = discount.value;
          const defaultLabel = `Buy ${discount.quantity} items get ${discountTypeSymbol === "$" ? "$" : ""}${dVal}${discountTypeSymbol === "%" ? "%" : ""} discount`;
          const labelText = discount.labelText || defaultLabel;
          headerHtml += `<span class="bundle-discount-badge"><svg fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7"></path></svg>${labelText}</span>`;
        });
        headerHtml += `</div>`;
      }
    }
    let html = headerHtml + '<div class="bundle-items">';

    // Render bundle collections
    if (hasCollections) {
      this.bundleCollections.forEach((col, colIndex) => {
        const wrapperId = `bundle-col-wrapper-${colIndex}`;

        const sortedProducts = col.products && col.products.length > 0 ? this.sortProductsCurrentFirst(col.products) : [];

        const firstProd = sortedProducts.length > 0 ? sortedProducts[0] : null;
        const isDefaultSelected = col.isDefaultSelected === true;

        if (isDefaultSelected && firstProd) {
          this.collectionStates[col.id] = {
            selectedProducts: [firstProd],
            isActive: true,
          };
        } else {
          this.collectionStates[col.id] = { selectedProducts: [], isActive: false };
        }

        let collectionsHtml = `<div class="bundle-collections-wrapper">`;
        if (sortedProducts.length > 0) {
          collectionsHtml += `
            <div class="bundle-col-title">${col.name ? col.name : "Add extra items:"}</div>
            <div class="bundle-slider-container">
          `;
          sortedProducts.forEach((cProd) => {
            collectionsHtml += this.renderCollectionOptionItemHTML(cProd, col.id, wrapperId);
          });
          collectionsHtml += `</div>`;
        }
        collectionsHtml += `</div>`;
        let colItemsHtml = "";
        if (isDefaultSelected && firstProd) {
          colItemsHtml = `<div class="bundle-col-product-group" data-product-id="${firstProd.id}">${this.renderColItemHTML(firstProd, true)}</div>`;
        }
        html += `
          <div class="bundle-col-container bundle-item-wrapper" id="${wrapperId}" data-col-id="${col.id}" data-is-collection="true">
            <div class="col-collections-wrapper">
              ${collectionsHtml}
              <div class="col-items-container flex flex-col">
                ${colItemsHtml}
              </div>
            </div>
          </div>
        `;
      });
    }

    html += "</div>";
    this.contentContainer.innerHTML = html;

    // Attach events for initial col-items
    this.contentContainer.querySelectorAll(".col-items-container").forEach((container) => {
      this.attachColItemDelegation(container);
    });

    this.attachEvents();
    this.setupTooltipPositioning();
    this.calculateTotal();
  }

  setupTooltipPositioning() {
    this.initSharedTooltip();
    // Bind shared-tooltip behavior for all tooltip triggers in container
    const tooltips = this.contentContainer.querySelectorAll(".bundle-tooltip");
    tooltips.forEach((tooltip) => {
      this.attachTooltipPositioningListener(tooltip);
    });
  }

  attachTooltipPositioningListener(tooltip) {
    if (!tooltip) return;

    const tooltipText = tooltip.querySelector(".bundle-tooltip-text");
    const tooltipContent = (tooltip.dataset.tooltipText || (tooltipText ? tooltipText.textContent : "") || "").trim();
    if (!tooltipContent) return;

    if (tooltip.dataset.tooltipListenerAttached === "true") return;
    tooltip.dataset.tooltipListenerAttached = "true";
    tooltip.dataset.tooltipText = tooltipContent;

    if (tooltipText) {
      tooltipText.style.display = "none";
    }

    tooltip.setAttribute("tabindex", "0");

    tooltip.addEventListener("mouseenter", () => {
      if (this.isCoarsePointer()) return;
      this.showSharedTooltip(tooltip);
    });

    tooltip.addEventListener("mouseleave", () => {
      if (this.isCoarsePointer()) return;
      this.hideSharedTooltip();
    });

    tooltip.addEventListener("focus", () => {
      this.showSharedTooltip(tooltip);
    });

    tooltip.addEventListener("blur", () => {
      this.hideSharedTooltip();
    });

    tooltip.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.showSharedTooltip(tooltip);
    });
  }

  initSharedTooltip() {
    if (!this.sharedTooltipEl) {
      const tooltipEl = document.createElement("div");
      tooltipEl.className = "bundle-shared-tooltip";
      tooltipEl.setAttribute("role", "tooltip");
      document.body.appendChild(tooltipEl);
      this.sharedTooltipEl = tooltipEl;
    }

    if (!this._onTooltipDocumentClick) {
      this._onTooltipDocumentClick = (e) => {
        if (!this.activeTooltipTrigger) return;
        const trigger = e.target.closest(".bundle-tooltip");
        const clickedInsideShared = this.sharedTooltipEl && this.sharedTooltipEl.contains(e.target);
        if (clickedInsideShared || trigger === this.activeTooltipTrigger) return;
        this.hideSharedTooltip();
      };
      document.addEventListener("click", this._onTooltipDocumentClick);
    }

    if (!this._onTooltipViewportChange) {
      this._onTooltipViewportChange = () => {
        this.repositionSharedTooltip();
      };
      window.addEventListener("resize", this._onTooltipViewportChange);
      window.addEventListener("scroll", this._onTooltipViewportChange, true);
    }
  }

  isCoarsePointer() {
    return !!(window.matchMedia && window.matchMedia("(pointer: coarse)").matches);
  }

  showSharedTooltip(tooltipTrigger) {
    if (!this.sharedTooltipEl || !tooltipTrigger) return;

    const content = (tooltipTrigger.dataset.tooltipText || "").trim();
    if (!content) return;

    this.activeTooltipTrigger = tooltipTrigger;
    this.sharedTooltipEl.textContent = content;
    this.sharedTooltipEl.classList.add("is-visible");
    this.repositionSharedTooltip();
  }

  hideSharedTooltip() {
    if (!this.sharedTooltipEl) return;
    this.sharedTooltipEl.classList.remove("is-visible", "is-bottom");
    this.activeTooltipTrigger = null;
  }

  repositionSharedTooltip() {
    if (!this.sharedTooltipEl || !this.activeTooltipTrigger || !this.sharedTooltipEl.classList.contains("is-visible")) {
      return;
    }

    const triggerRect = this.activeTooltipTrigger.getBoundingClientRect();
    const tooltipRect = this.sharedTooltipEl.getBoundingClientRect();
    const gap = 10;
    const viewportPadding = 10;

    let left = triggerRect.left + triggerRect.width / 2;
    const minCenterX = viewportPadding + tooltipRect.width / 2;
    const maxCenterX = window.innerWidth - viewportPadding - tooltipRect.width / 2;
    left = Math.max(minCenterX, Math.min(maxCenterX, left));

    let top = triggerRect.top - tooltipRect.height - gap;
    let showBottom = false;

    if (top < viewportPadding) {
      top = triggerRect.bottom + gap;
      showBottom = true;
    }

    if (top + tooltipRect.height > window.innerHeight - viewportPadding) {
      top = Math.max(viewportPadding, window.innerHeight - viewportPadding - tooltipRect.height);
    }

    this.sharedTooltipEl.style.left = `${left}px`;
    this.sharedTooltipEl.style.top = `${top}px`;
    this.sharedTooltipEl.classList.toggle("is-bottom", showBottom);
  }

  normalizeInputTypes(rawInputTypes) {
    let parsed = rawInputTypes;

    if (typeof parsed === "string") {
      try {
        parsed = JSON.parse(parsed);
      } catch (e) {
        parsed = null;
      }
    }

    let list = [];
    if (Array.isArray(parsed)) {
      list = parsed;
    } else if (parsed && typeof parsed === "object") {
      list = [parsed];
    }

    const result = list
      .filter(Boolean)
      .map((it) => ({
        type: it.type || "",
        label: it.label || "",
        required: it.required === true || it.required === "true",
        placeholder: it.placeholder || "",
        description_optional: it.description_optional || it.description || "",
      }));

    return result;
  }

  getProductInputTypes(product) {
    return this.normalizeInputTypes(product ? product.inputTypes : null);
  }

  getColItemInputTypes(colItem) {
    const inputTypesFromDataset = colItem ? colItem.dataset.inputTypes : null;

    return this.normalizeInputTypes(inputTypesFromDataset);
  }

  buildInputTypesDataAttr(inputTypes) {
    const normalized = this.normalizeInputTypes(inputTypes);
    return JSON.stringify(normalized).replace(/"/g, "&quot;");
  }

  getTextInputTypes(inputTypes) {
    return inputTypes.filter((it) => (it.type || "") === "Text Input");
  }

  getAllInputTypes(inputTypes) {
    return inputTypes.filter((it) => it.type && (it.type === "Text Input" || it.type === "Image"));
  }

  renderCollectionOptionItemHTML(cProd, colId, targetWrapperId) {
    const state = this.collectionStates[colId];
    const currentVarId = String(cProd.variantId || cProd.id || "");
    const isSelected = state && state.selectedProducts.some((p) => String(p.variantId || p.id || "") === currentVarId);
    const inputTypesDataAttr = this.buildInputTypesDataAttr(cProd.inputTypes);

    const cPriceStr = cProd.price ? (cProd.price / 100).toFixed(2) : "0.00";
    const cCompareStr = cProd.compareAtPrice > cProd.price ? `<span class="bundle-option-item__compare">$${(cProd.compareAtPrice / 100).toFixed(2)}</span>` : "";

    return `
      <div class="bundle-option-item bundle-col-option-item ${isSelected ? "selected" : ""}"
        data-col-id="${colId}"
        data-target-wrapper="${targetWrapperId}"
        data-product-id="${cProd.id}"
        data-variant-id="${currentVarId}"
        data-title="${(cProd.title || "").replace(/"/g, "&quot;")}"
        data-price="${cProd.price}"
        data-compare="${cProd.compareAtPrice || 0}"
        data-image="${cProd.image}"
        data-full-image="${cProd.fullImage}"
        data-url="${cProd.url}"
        data-variant-title="${cProd.variantTitle || ""}"
        data-input-types="${inputTypesDataAttr}"
      >
        <div class="bundle-option-check">✓</div>
        <div class="bundle-option-item__image">
          <img src="${cProd.image}" alt="${(cProd.title || "").replace(/"/g, "&quot;")}">
        </div>
        <div class="bundle-option-item__title" title="${(cProd.title || "").replace(/"/g, "&quot;")}">${cProd.title}</div>
        <div class="bundle-option-item__price">$${cPriceStr}${cCompareStr}</div>
      </div>
    `;
  }

  attachEvents() {
    this.contentContainer.querySelectorAll(".bundle-col-option-item").forEach((item) => {
      item.addEventListener("click", (e) => {
        const optionEl = e.currentTarget;
        const colId = optionEl.dataset.colId;
        const targetWrapperId = optionEl.dataset.targetWrapper;
        const targetWrapper = document.getElementById(targetWrapperId);

        if (!targetWrapper || !this.collectionStates[colId]) return;

        const itemsContainer = targetWrapper.querySelector(".col-items-container");
        const state = this.collectionStates[colId];

        const isSelected = optionEl.classList.contains("selected");
        const currentVariantId = optionEl.dataset.variantId;

        const collection = this.bundleCollections.find((c) => String(c.id) === String(colId));
        const originalProd = collection ? collection.products.find((p) => String(p.variantId || p.id || "") === String(currentVariantId)) : null;

        const newProductData = originalProd
          ? JSON.parse(JSON.stringify(originalProd))
          : {
            id: optionEl.dataset.productId,
            variantId: currentVariantId,
            price: optionEl.dataset.price,
            compareAtPrice: optionEl.dataset.compare,
            title: optionEl.dataset.title,
            image: optionEl.dataset.image,
            fullImage: optionEl.dataset.fullImage,
            url: optionEl.dataset.url,
            variantTitle: optionEl.dataset.variantTitle,
            inputType: optionEl.dataset.inputType,
            inputLabel: optionEl.dataset.inputLabel,
            isRequired: optionEl.dataset.isRequired === "true",
            description: optionEl.dataset.description,
            placeholder: optionEl.dataset.placeholder,
            inputTypes: this.normalizeInputTypes(
              optionEl.dataset.inputTypes,
              optionEl.dataset.inputType,
              optionEl.dataset.inputLabel,
              optionEl.dataset.isRequired === "true",
              optionEl.dataset.placeholder,
              optionEl.dataset.description
            ),
            variants: null,
          };

        if (!newProductData.variants && collection && collection.products) {
          const masterProd = collection.products.find((p) => String(p.id) === String(newProductData.id));
          if (masterProd && masterProd.variants) {
            newProductData.variants = masterProd.variants;
          }
        }
        if (isSelected) {
          const productId = optionEl.dataset.productId;

          optionEl.classList.remove("selected");

          // Remove entire product group wrapper
          const productGroup = itemsContainer.querySelector(`.bundle-col-product-group[data-product-id="${productId}"]`);
          if (productGroup) {
            productGroup.remove();
          }

          const syncedState = this.syncCollectionStateFromContainer(targetWrapper);
        } else {
          state.selectedProducts.unshift(newProductData);

          optionEl.classList.add("selected");

          const colItemHtml = this.renderColItemHTML(newProductData);
          const groupHtml = `<div class="bundle-col-product-group" data-product-id="${newProductData.id}">${colItemHtml}</div>`;
          itemsContainer.insertAdjacentHTML("afterbegin", groupHtml);
          const newGroup = itemsContainer.firstElementChild;
          const newItem = newGroup.firstElementChild;
          // Setup tooltip positioning for new item
          const tooltips = newItem.querySelectorAll(".bundle-tooltip");
          tooltips.forEach((tooltip) => {
            this.attachTooltipPositioningListener(tooltip);
          });
          if (state.selectedProducts.length === 1) {
            state.isActive = true;
          }
          this.syncCollectionStateFromContainer(targetWrapper);
        }

        this.calculateTotal();
      });
    });

    if (this.addToCartBtn) {
      this.addToCartBtn.addEventListener("click", this.handleAddToCart.bind(this));
    }
  }

  calculateTotal() {
    let total = 0;
    let selectedQuantity = 0;
    let hasSelected = false;
    this.contentContainer.querySelectorAll(".bundle-col-container").forEach((wrapper) => {
      const colId = wrapper.dataset.colId;
      const state = this.collectionStates[colId];
      if (!state || !state.isActive) {
        return;
      }

      const items = wrapper.querySelectorAll(".bundle-col-item");

      items.forEach((item) => {
        hasSelected = true;
        const qtyInput = item.querySelector(".col-qty-input");
        const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

        const priceStr = item.dataset.price;
        if (!priceStr || isNaN(parseInt(priceStr))) return;
        const price = parseInt(priceStr) || 0;
        total += price * quantity;
        selectedQuantity += quantity;
      });
    });

    let discountValue = 0;
    let discountText = "";

    if (this.bundleInfo && Array.isArray(this.bundleInfo.discount) && this.bundleInfo.discount.length > 0) {
      // Find the best applicable discount (highest quantity threshold met)
      const applicableDiscounts = this.bundleInfo.discount.filter((d) => d && selectedQuantity >= (d.quantity || 1));
      if (applicableDiscounts.length > 0) {
        // Sort by quantity descending to get the largest threshold met
        applicableDiscounts.sort((a, b) => (b.quantity || 1) - (a.quantity || 1));
        const bestDiscount = applicableDiscounts[0];

        const dType = (bestDiscount.type || "").toLowerCase();
        const dDiscountType = (bestDiscount.discountType || "").toLowerCase();
        const actualType = dType || dDiscountType || "percentage";
        const dVal = bestDiscount.value || 0;

        if (actualType === "percentage") {
          discountValue = total * (dVal / 100);
          discountText = `(${dVal}% OFF)`;
        } else if (actualType === "fixed_amount") {
          discountValue = dVal * 100;
          discountText = `($${dVal} OFF)`;
        }
      }
    }

    discountValue = Math.min(discountValue, total);
    const discountedTotal = total - discountValue;

    if (this.totalContainer) {
      let totalHtml = `<div style="color: #333; font-weight: 700;">Total bundle price ${discountValue > 0 ? discountText : ""}:</div>`;
      totalHtml += `<div class="flex items-center gap-2">`;
      totalHtml += `<strong style="color: #111;">$${(discountedTotal / 100).toFixed(2)}</strong>`;
      if (discountValue > 0) {
        totalHtml += `<strike style="color:#888; text-decoration-thickness: 2px;">$${(total / 100).toFixed(2)}</strike>`;
      }
      totalHtml += `</div>`;
      this.totalContainer.innerHTML = totalHtml;
    }

    if (this.addToCartBtn) {
      const btnSpan = this.addToCartBtn.querySelector("span") || this.addToCartBtn;
      if (discountValue > 0) {
        btnSpan.textContent = `Add Bundle To Cart ${discountText}`;
      } else {
        btnSpan.textContent = `Add Bundle To Cart`;
      }
    }

    this.footerContainer.style.display = hasSelected ? "block" : "none";
  }

  // Validate file size (5MB max)
  validateFileSize(file) {
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      throw new Error(`File size (${(file.size / 1024 / 1024).toFixed(2)}MB) exceeds 5MB limit`);
    }
    return true;
  }

  async handleAddToCart() {
    let hasError = false;
    let itemCount = 0;

    this.contentContainer.querySelectorAll(".col-custom-property-input").forEach((input) => {
      input.style.borderColor = "#ccc";
      const errorMsg = input.parentElement.querySelector(".custom-property-error");
      if (errorMsg) errorMsg.style.display = "none";
    });

    // Validate all inputs first
    const containers = Array.from(this.contentContainer.querySelectorAll(".bundle-col-container"));

    for (const wrapper of containers) {
      const colId = wrapper.dataset.colId;
      const state = this.collectionStates[colId];
      if (!state || !state.isActive) continue;

      const currentItems = Array.from(wrapper.querySelectorAll(".bundle-col-item"));

      for (const item of currentItems) {
        const customInputs = Array.from(item.querySelectorAll(".col-custom-property-input"));

        for (const customInput of customInputs) {
          const isImage = customInput.classList.contains("bundle-image-input");

          if (isImage) {
            // Validate image file input
            const file = customInput.files?.[0];
            if (customInput.dataset.isRequired === "true" && !file) {
              customInput.style.borderColor = "red";
              const errorMsg = customInput.parentElement.querySelector(".custom-property-error");
              if (errorMsg) errorMsg.style.display = "block";
              if (!hasError) customInput.scrollIntoView({ behavior: "smooth", block: "center" });
              hasError = true;
              continue;
            }

            if (file) {
              try {
                this.validateFileSize(file);
                customInput.style.borderColor = "#ccc";
                const errorMsg = customInput.parentElement.querySelector(".custom-property-error");
                if (errorMsg) errorMsg.style.display = "none";
              } catch (error) {
                customInput.style.borderColor = "red";
                const errorMsg = customInput.parentElement.querySelector(".custom-property-error");
                if (errorMsg) {
                  errorMsg.textContent = error.message;
                  errorMsg.style.display = "block";
                }
                if (!hasError) customInput.scrollIntoView({ behavior: "smooth", block: "center" });
                hasError = true;
              }
            }
          } else {
            // Validate text input
            if (customInput.dataset.isRequired === "true" && customInput.value.trim() === "") {
              customInput.style.borderColor = "red";
              const errorMsg = customInput.parentElement.querySelector(".custom-property-error");
              if (errorMsg) errorMsg.style.display = "block";
              if (!hasError) customInput.scrollIntoView({ behavior: "smooth", block: "center" });
              hasError = true;
              continue;
            }
            if (customInput.value.trim() !== "") {
              customInput.style.borderColor = "#ccc";
              const errorMsg = customInput.parentElement.querySelector(".custom-property-error");
              if (errorMsg) errorMsg.style.display = "none";
            }
          }
        }
      }
    }

    if (hasError) {
      bundleLog("error", "[validation]", "Validation failed");
      return;
    }

    // Build array of items to add (Shopify /cart/add only accepts 1 item per request)
    const itemsToAdd = [];

    for (const wrapper of containers) {
      const colId = wrapper.dataset.colId;
      const state = this.collectionStates[colId];
      if (!state || !state.isActive) continue;

      const currentItems = Array.from(wrapper.querySelectorAll(".bundle-col-item"));

      for (const item of currentItems) {
        const variantId = parseInt(item.dataset.variantId);
        const qtyInput = item.querySelector(".col-qty-input");
        const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

        const customInputs = Array.from(item.querySelectorAll(".col-custom-property-input"));
        const properties = {};
        const files = {};

        for (const customInput of customInputs) {
          const isImage = customInput.classList.contains("bundle-image-input");
          const propertyName = customInput.dataset.propertyName || "property";

          if (isImage) {
            const file = customInput.files?.[0];
            if (file) {
              files[propertyName] = file;
            }
          } else {
            const value = customInput.value.trim();
            if (value) {
              properties[propertyName] = value;
            }
          }
        }

        itemsToAdd.push({ variantId, quantity, properties, files });
        itemCount++;
      }
    }

    if (itemCount === 0) {
      bundleLog("error", "[validation]", "Please select at least one item");
      return;
    }

    try {
      // Add each item sequentially to cart
      for (let i = 0; i < itemsToAdd.length; i++) {
        const item = itemsToAdd[i];
        const itemFormData = new FormData();

        itemFormData.append("form_type", "product");
        itemFormData.append("utf8", "✓");
        itemFormData.append("id", item.variantId);
        itemFormData.append("quantity", item.quantity);

        for (const [key, value] of Object.entries(item.properties)) {
          itemFormData.append(`properties[${key}]`, value);
        }

        for (const [key, file] of Object.entries(item.files)) {
          itemFormData.append(`properties[${key}]`, file);
        }

        const fetchOptions = {
          method: "POST",
          body: itemFormData,
          credentials: "include",
          redirect: "follow",
        };

        if (i === itemsToAdd.length - 1) {
          fetchOptions.headers = {
            "accept": "application/javascript",
            "x-requested-with": "XMLHttpRequest",
          };
        }

        const response = await fetch(window.Shopify.routes.root + "cart/add", fetchOptions);

        if (!response.ok) {
          bundleLog("error", "Error", `Failed to add item ${i + 1}. Status: ${response.status}`);
        }
      }

      // Fetch cart data to refresh cart display
      const cartResponse = await fetch(window.Shopify.routes.root + "cart.js", {
        method: "GET",
        credentials: "include",
        headers: { "Accept": "application/json" },
      });

      if (cartResponse.ok) {
        const cartData = await cartResponse.json();
        // Dispatch custom event with cart data for other components
        window.dispatchEvent(
          new CustomEvent("bundle:cart-updated", {
            detail: { cart: cartData },
            bubbles: true,
          })
        );
      }
    } catch (error) {
      bundleLog("error", "Error", "Error adding items to cart:", error);
    }
  }

  updateItemFromVariant(item, checkedInput) {
    if (!item || !checkedInput) return;

    // Save existing custom input values BEFORE updating variantId (which changes input ids)
    const inputWrapper = item.querySelector(".bundle-item__custom-input");
    const savedInputValues = [];
    if (inputWrapper) {
      inputWrapper.querySelectorAll(".col-custom-property-input").forEach((inp) => {
        savedInputValues.push(inp.value);
      });
    }

    item.dataset.variantId = checkedInput.value;
    item.dataset.price = checkedInput.dataset.price;
    if (checkedInput.dataset.inputType) item.dataset.inputType = checkedInput.dataset.inputType;
    if (checkedInput.dataset.inputLabel) item.dataset.inputLabel = checkedInput.dataset.inputLabel;
    if (checkedInput.dataset.isRequired) item.dataset.isRequired = checkedInput.dataset.isRequired;
    if (checkedInput.dataset.placeholder) item.dataset.placeholder = checkedInput.dataset.placeholder;
    if (checkedInput.dataset.description) item.dataset.description = checkedInput.dataset.description;
    if (checkedInput.dataset.inputTypes) item.dataset.inputTypes = checkedInput.dataset.inputTypes;

    const fPrice = parseFloat(checkedInput.dataset.price) || 0;
    const fCompare = parseFloat(checkedInput.dataset.compare) || 0;

    const priceEl = item.querySelector(".bundle-dynamic-price");
    if (priceEl) priceEl.textContent = "$" + (fPrice / 100).toFixed(2);

    const compareWrapper = item.querySelector(".bundle-dynamic-compare-wrapper");
    if (compareWrapper) {
      if (fCompare > fPrice) {
        compareWrapper.innerHTML = `<span class="bundle-item__compare bundle-dynamic-compare">$${(fCompare / 100).toFixed(2)}</span>`;
      } else {
        compareWrapper.innerHTML = "";
      }
    }

    const variantTitleEl = item.querySelector(".bundle-dynamic-variant");
    if (variantTitleEl) {
      const fTitle = checkedInput.dataset.variantTitle;
      const labelEl = variantTitleEl.querySelector(".bundle-dynamic-variant-label");
      if (fTitle && fTitle !== "Default Title") {
        variantTitleEl.style.display = "";
        if (labelEl) {
          labelEl.textContent = fTitle;
        } else {
          // Rebuild inner content if label span missing (non-trigger variant p)
          variantTitleEl.innerHTML = `Variants: <span class="bundle-dynamic-variant-label" style="text-decoration: underline;">${fTitle}</span> <span class="bundle-variants-arrow">▼</span>`;
        }
      } else {
        if (variantTitleEl.classList.contains("bundle-variant-trigger")) {
          variantTitleEl.style.display = "";
          if (labelEl) labelEl.textContent = "Select Variant";
        } else {
          variantTitleEl.style.display = "none";
        }
      }
    }

    const imgEl = item.querySelector(".bundle-dynamic-img");
    const fImg = checkedInput.dataset.image;
    if (imgEl && fImg && fImg !== "undefined") {
      if (imgEl.tagName === "IMG") {
        imgEl.src = fImg;
      } else {
        const newImgHtml = `<img src="${fImg}" alt="${checkedInput.dataset.title}" class="bundle-dynamic-img" />`;
        imgEl.outerHTML = newImgHtml;
      }
    }

    const zoomWrapper = item.querySelector(".bundle-dynamic-image-zoom");
    const fFullImg = checkedInput.dataset.fullImage;
    if (zoomWrapper && fFullImg && fFullImg !== "undefined") {
      zoomWrapper.dataset.fullImage = fFullImg;
    }

    // Restore saved input values after variant update
    if (inputWrapper && savedInputValues.length > 0) {
      const currentInputs = inputWrapper.querySelectorAll(".col-custom-property-input");
      currentInputs.forEach((inp, i) => {
        if (i < savedInputValues.length) {
          inp.value = savedInputValues[i];
        }
      });
    }
  }

  renderVariantsAccordionHTML(product, selectedVariantId, fallbackImage, fallbackFullImage) {
    if (!product.variants || product.variants.length <= 1) return "";

    const inputTypesDataAttr = this.buildInputTypesDataAttr(product.inputTypes);

    const variantsDataHtml = product.variants
      .map((v) => {
        const vUrl = product.url || "#";
        const vTitle = product.title || "";
        const vVariantTitle = v.title || "";
        const vProductId = product.id || "";
        const vImage = v.image ? v.image : fallbackImage;
        const vFullImage = v.fullImage ? v.fullImage : fallbackFullImage;
        const isChecked = v.id == selectedVariantId;
        return `
          <input type="checkbox" class="bundle-variant-checkbox" value="${v.id}"
            data-price="${v.price}"
            data-compare="${v.compareAtPrice || 0}"
            data-title="${(vTitle || "").replace(/"/g, "&quot;")}"
            data-variant-title="${(vVariantTitle || "").replace(/"/g, "&quot;")}"
            data-image="${vImage}"
            data-full-image="${vFullImage}"
            data-url="${vUrl}"
            data-product-id="${vProductId}"
            data-input-types="${inputTypesDataAttr}"
            ${isChecked ? "checked" : ""} ${!v.available ? "disabled" : ""}
            style="display:none;"
          />
        `;
      })
      .join("");

    return `<div class="bundle-variants-data" style="display:none;">${variantsDataHtml}</div>`;
  }

  renderColItemHTML(product) {
    const variantId = product.variantId || product.id;
    const title = product.title || "Product";
    const url = product.url || "#";
    const price = product.price || 0;
    const compareAtPrice = product.compareAtPrice || 0;
    const image = product.image || "";
    const fullImage = product.fullImage || image;
    const productId = product.id || "";
    const inputTypesDataAttr = this.buildInputTypesDataAttr(product.inputTypes);

    const priceInDollars = (price / 100).toFixed(2);
    const originalPriceHtml = this.renderComparePriceHTML(compareAtPrice, price);
    const removeButtonHtml = this.renderRemoveButtonHTML(variantId);
    // const addButtonHtml = this.renderAddButtonHTML(product.id);
    const variantsDataHtml = this.renderVariantsAccordionHTML(product, variantId, image, fullImage);

    return `
      <div class="bundle-col-item"
        data-url="${url}"
        data-product-title="${(title || "").replace(/"/g, "&quot;")}"
        data-product-id="${productId}"
        data-variant-id="${variantId}"
        data-price="${price}"
        data-input-types="${inputTypesDataAttr}"
        data-can-be-added="${product.canBeAdded || false}"
      >
        <div class="bundle-main-details">
          <div class="flex-shrink-0 flex flex-col gap-2 bundle-col-item__image-col">
            ${this.renderImageWrapperHTML(image, title, fullImage, productId)}
            ${removeButtonHtml}
          </div>
          <div class="bundle-item__info flex-grow flex flex-col" style="width: calc(100% - 100px);">
            <p class="bundle-item__title m-0 leading-snug text-gray-900"><a href="${url}" class="bundle-dynamic-url" target="_blank">${title}</a></p>
            ${this.renderVariantDisplayHTML(product, variantsDataHtml)}
            ${variantsDataHtml}
            ${this.renderCustomInputHTML(product, variantId)}
            <div class="flex items-center justify-between bundle-item_footer">
              <div class="bundle-item__prices flex items-center">
                <span class="bundle-item__price font-bold bundle-dynamic-price">$${priceInDollars}</span>
                <span class="bundle-dynamic-compare-wrapper">${originalPriceHtml}</span>
              </div>
              <div class="bundle-item__quantity flex items-center">
                <button type="button" class="col-qty-btn col-qty-minus" data-variant-id="${variantId}">−</button>
                <input type="number" class="col-qty-input text-center bg-transparent border-none bundle-dynamic-qty-input" value="1" min="1" data-variant-id="${variantId}" />
                <button type="button" class="col-qty-btn col-qty-plus" data-variant-id="${variantId}">+</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
  }

  renderComparePriceHTML(compareAtPrice, price) {
    if (compareAtPrice <= price) return "";
    return `<span class="bundle-item__compare">$${(compareAtPrice / 100).toFixed(2)}</span>`;
  }

  renderRemoveButtonHTML(variantId) {
    return `<button type="button" class="col-item-remove-btn addon-remove-btn" data-variant-id="${variantId}">&times;</button>`;
  }

  renderAddButtonHTML(productId) {
    return `<button type="button" class="col-item-add-btn" data-product-id="${productId}" title="Add another item">+ Add Items</button>`;
  }

  renderImageWrapperHTML(image, title, fullImage, productId) {
    const imgContent = image ? `<img src="${image}" alt="${title}" class="bundle-dynamic-img" />` : '<div class="bundle-dynamic-no-img">No Image</div>';

    return `
      <div class="wrapper-image-bundle">
        <image-zoom-wrapper class="bundle-item__image bundle-dynamic-image-zoom" data-full-image="${fullImage}" title="Click to zoom">
          ${imgContent}
          <div class="bundle-col-item__zoom-icon">
            <svg fill="none"
              width="12"
              height="12"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                <line x1="11" y1="8" x2="11" y2="14"></line>
                <line x1="8" y1="11" x2="14" y2="11"></line>
            </svg>
          </div>
        </image-zoom-wrapper>
        ${this.renderAddButtonHTML(productId)}
      </div>
    `;
  }

  renderVariantDisplayHTML(product, variantsDataHtml) {
    if (!variantsDataHtml) {
      return `<p class="bundle-item__variant text-blue-600 bundle-dynamic-variant" style="display:none;"></p>`;
    }

    const variantLabel =
      product.variantTitle && product.variantTitle !== "Default Title"
        ? `Variants: <span class="bundle-dynamic-variant-label" style="text-decoration: underline;">${product.variantTitle}</span>`
        : `Select Variant`;

    return `
      <p class="bundle-item__variant text-blue-600 bundle-dynamic-variant bundle-variant-trigger" style="cursor:pointer;">
        ${variantLabel}
        <span class="bundle-variants-arrow">▼</span>
      </p>
    `;
  }

  renderCustomInputHTML(product, variantId) {
    const inputTypes = this.getAllInputTypes(this.getProductInputTypes(product));
    if (!inputTypes.length) return "";

    const fieldsHtml = inputTypes
      .map((inputDef, index) => {
        const inputLabel = inputDef.label || "Customize";
        const required = inputDef.required ? ' <span style="color: red; margin-left: 2px;">*</span>' : "";
        const inputId = `col-custom-input-${variantId}-${index}`;
        const tooltip = this.renderCustomInputTooltipHTML(inputDef.description_optional);

        if (inputDef.type === "Image") {
          return `
            <div class="bundle-custom-input-group">
              <label class="bundle-custom-input-label block flex items-center flex-wrap" for="${inputId}">
                ${inputLabel}${required}:
                ${tooltip}
              </label>
              <input type="file" id="${inputId}" class="bundle-custom-input bundle-image-input custom-property-input col-custom-property-input"
                accept="image/*"
                data-property-name="${inputLabel}"
                data-input-type="Image"
                data-is-required="${inputDef.required}"
              />
              <small style="color: #666; margin-top: 4px; display: block;">Max file size: 5MB</small>
              <div class="custom-property-error">${inputLabel} is required.</div>
            </div>
          `;
        }

        // Default: Text Input
        const placeholder = this.getCustomInputPlaceholder({
          inputLabel: inputLabel,
          placeholder: inputDef.placeholder,
        });
        return `
          <div class="bundle-custom-input-group">
            <label class="bundle-custom-input-label block flex items-center flex-wrap" for="${inputId}">
              ${inputLabel}${required}:
              ${tooltip}
            </label>
            <input type="text" id="${inputId}" class="bundle-custom-input custom-property-input col-custom-property-input"
              placeholder="${placeholder}"
              data-property-name="${inputLabel}"
              data-input-type="Text Input"
              data-is-required="${inputDef.required}"
            />
            <div class="custom-property-error">${inputLabel} is required.</div>
          </div>
        `;
      })
      .join("");

    return `
      <div class="bundle-item__custom-input w-full">
        ${fieldsHtml}
      </div>
    `;
  }

  getCustomInputPlaceholder(product) {
    const inputLabel = product.inputLabel || "Customize Your Stole";
    if (product.placeholder && product.placeholder !== "null") {
      return product.placeholder;
    }
    return `Enter ${inputLabel}...`;
  }

  renderCustomInputTooltipHTML(description) {
    if (!description || description === "null") return "";

    return `
      <div class="bundle-tooltip">
        ?
        <div class="bundle-tooltip-text">${description}</div>
      </div>
    `;
  }

  syncCollectionStateFromContainer(colContainer) {
    if (!colContainer) return null;

    const colId = colContainer.dataset.colId;
    if (!colId) return null;

    const state = this.collectionStates[colId] || { selectedProducts: [], isActive: false };
    const primaryItems = Array.from(colContainer.querySelectorAll(".bundle-col-item:not([data-is-variant-addon='true'])"));

    state.selectedProducts = primaryItems.map((item) => ({
      id: item.dataset.productId,
      variantId: item.dataset.variantId,
      price: parseInt(item.dataset.price) || 0,
      compareAtPrice: parseInt(item.dataset.compare) || 0,
      title: item.dataset.productTitle || "",
      image: item.dataset.image || "",
      fullImage: item.dataset.fullImage || item.dataset.image || "",
      url: item.dataset.url || "#",
      variantTitle: item.dataset.variantTitle || "",
      inputTypes: this.normalizeInputTypes(item.dataset.inputTypes),
      canBeAdded: item.dataset.canBeAdded === "true",
    }));
    state.isActive = primaryItems.length > 0;

    this.collectionStates[colId] = state;
    return state;
  }

  attachColItemDelegation(container) {
    if (!container) return;

    // Click delegation
    container.addEventListener("click", (e) => {
      const target = e.target;

      // Qty minus
      const minusBtn = target.closest(".col-qty-minus");
      if (minusBtn) {
        e.preventDefault();
        const input = minusBtn.parentElement.querySelector(".col-qty-input");
        if (input && parseInt(input.value) > 1) {
          input.value = parseInt(input.value) - 1;
          this.calculateTotal();
        }
        return;
      }

      // Qty plus
      const plusBtn = target.closest(".col-qty-plus");
      if (plusBtn) {
        e.preventDefault();
        const input = plusBtn.parentElement.querySelector(".col-qty-input");
        if (input) {
          input.value = parseInt(input.value) + 1;
          this.calculateTotal();
        }
        return;
      }

      // Remove button
      const removeBtn = target.closest(".col-item-remove-btn");
      if (removeBtn) {
        const colItem = removeBtn.closest(".bundle-col-item");
        if (colItem) {
          this.removeColItem(colItem);
        }
        return;
      }

      // Add button
      const addBtn = target.closest(".col-item-add-btn");
      if (addBtn) {
        e.preventDefault();
        e.stopPropagation();
        const colItem = addBtn.closest(".bundle-col-item");
        if (colItem) {
          this.handleColItemAddClick(colItem, container);
        }
        return;
      }

      // Variant trigger
      const variantTrigger = target.closest(".bundle-dynamic-variant.bundle-variant-trigger");
      if (variantTrigger) {
        e.stopPropagation();
        const colItem = variantTrigger.closest(".bundle-col-item");
        if (colItem) {
          const isVariantAddon = colItem.dataset.isVariantAddon === "true";
          if (isVariantAddon) {
            const productId = colItem.dataset.productId;
            const colContainer = container.closest(".bundle-col-container");
            if (colContainer) {
              const primaryItem = this.findPrimaryItemByProductId(colContainer, productId);
              if (primaryItem) {
                this.openVariantPopup(primaryItem);
              }
            }
          } else {
            this.openVariantPopup(colItem);
          }
        }
        return;
      }

      // Variants accordion header
      const header = target.closest(".bundle-variants-header");
      if (header) {
        const content = header.nextElementSibling;
        const arrow = header.querySelector(".bundle-variants-arrow");
        const computedDisplay = window.getComputedStyle(content).display;
        if (computedDisplay === "none") {
          content.style.display = "block";
          if (arrow) arrow.textContent = "▲";
        } else {
          content.style.display = "none";
          if (arrow) arrow.textContent = "▼";
        }
        return;
      }
    });

    // Change delegation
    container.addEventListener("change", (e) => {
      const target = e.target;

      // Image input file validation
      if (target.classList.contains("bundle-image-input")) {
        const file = target.files?.[0];
        const errorMsg = target.parentElement.querySelector(".custom-property-error");
        const maxSize = 5 * 1024 * 1024; // 5MB

        if (file) {
          if (file.size > maxSize) {
            target.style.borderColor = "red";
            if (errorMsg) {
              errorMsg.textContent = `File size (${(file.size / 1024 / 1024).toFixed(2)}MB) exceeds 5MB limit`;
              errorMsg.style.display = "block";
            }
            target.value = ""; // Clear selection
          } else {
            target.style.borderColor = "#ccc";
            if (errorMsg) errorMsg.style.display = "none";
          }
        }
        return;
      }

      // Qty input
      if (target.classList.contains("col-qty-input")) {
        if (parseInt(target.value) < 1 || isNaN(parseInt(target.value))) {
          target.value = 1;
        }
        const colItem = target.closest(".bundle-col-item");
        if (colItem) this.syncCustomInputsToQty(colItem);
        this.calculateTotal();
        return;
      }

      // Variant checkbox
      if (target.classList.contains("bundle-variant-checkbox")) {
        this.handleVariantCheckboxChange(target);
        return;
      }
    });
  }

  bindColVariantCheckbox(cb) {
    cb.addEventListener("change", () => {
      this.handleVariantCheckboxChange(cb);
    });
  }

  removeColItem(item) {
    if (!item) return;
    const productId = item.dataset.productId;
    const colContainer = item.closest(".bundle-col-container");
    const productGroup = item.closest(".bundle-col-product-group");

    // Remove the item from DOM
    item.remove();

    // Check if product group is now empty
    if (productGroup) {
      const remainingItems = productGroup.querySelectorAll(".bundle-col-item");
      if (remainingItems.length === 0) {
        productGroup.remove();
        // Deselect the option item (triggers click which updates state)
        if (colContainer) {
          const optionEl = colContainer.querySelector(`.bundle-col-option-item[data-product-id="${productId}"]`);
          if (optionEl) {
            optionEl.click();
            return; // click handler already calls calculateTotal
          }
        }
      }
    }

    // Sync selectedProducts/state from DOM so footer visibility stays correct.
    if (colContainer) {
      this.syncCollectionStateFromContainer(colContainer);
    }

    this.calculateTotal();
  }
  handleVariantCheckboxChange(cb) {
    const colItem = cb.closest(".bundle-col-item");
    const itemsContainer = cb.closest(".col-items-container");
    const colWrapper = cb.closest(".bundle-col-container");
    if (!colItem || !itemsContainer) return;

    const isChecked = cb.checked;
    const canBeAdded = colItem.dataset.canBeAdded === "true";
    const productId = cb.dataset.productId;
    const variantsData = cb.closest(".bundle-variants-data");
    if (!variantsData) return;

    if (!canBeAdded && isChecked) {
      const allVariantCheckboxes = Array.from(variantsData.querySelectorAll(".bundle-variant-checkbox"));
      allVariantCheckboxes.forEach((checkbox) => {
        if (checkbox !== cb && checkbox.checked) {
          checkbox.checked = false;
        }
      });
    }

    const allChecked = Array.from(variantsData.querySelectorAll(".bundle-variant-checkbox:checked"));

    if (allChecked.length === 0) {
      this.removeColItem(colItem);
    } else {
      this.updateItemFromVariant(colItem, allChecked[0]);

      if (!canBeAdded) {
        const existingVariantAddons = itemsContainer.querySelectorAll(`.bundle-col-item[data-is-variant-addon="true"][data-product-id="${productId}"]`);
        existingVariantAddons.forEach((addon) => {
          addon.remove();
        });
      } else {
        if (isChecked) {
          const colId = colWrapper.dataset.colId;
          const collection = this.bundleCollections.find((c) => String(c.id) === String(colId));
          const masterProd = collection ? collection.products.find((p) => String(p.id) === String(productId)) : null;
          const fakeProd = {
            id: cb.dataset.productId,
            variantId: cb.value,
            price: cb.dataset.price,
            compareAtPrice: cb.dataset.compare,
            title: cb.dataset.title,
            image: cb.dataset.image,
            fullImage: cb.dataset.fullImage,
            url: cb.dataset.url || "#",
            variantTitle: cb.dataset.variantTitle,
            inputType: colItem.dataset.inputType || "",
            inputLabel: colItem.dataset.inputLabel || "",
            isRequired: colItem.dataset.isRequired === "true",
            description: colItem.dataset.description || "",
            placeholder: colItem.dataset.placeholder || "",
            inputTypes: this.normalizeInputTypes(
              cb.dataset.inputTypes || colItem.dataset.inputTypes,
              colItem.dataset.inputType,
              colItem.dataset.inputLabel,
              colItem.dataset.isRequired === "true",
              colItem.dataset.placeholder,
              colItem.dataset.description
            ),
            variants: masterProd ? masterProd.variants : null,
            canBeAdded: canBeAdded,
          };
          const productGroup = itemsContainer.querySelector(`.bundle-col-product-group[data-product-id="${productId}"]`);
          const insertTarget = productGroup || colItem.parentElement;
          insertTarget.insertAdjacentHTML("afterbegin", this.renderColItemHTML(fakeProd));
          const newAddon = insertTarget.firstElementChild;
          newAddon.dataset.isVariantAddon = "true";
          newAddon.dataset.productId = colItem.dataset.productId;

          const tooltips = newAddon.querySelectorAll(".bundle-tooltip");
          tooltips.forEach((tooltip) => {
            this.attachTooltipPositioningListener(tooltip);
          });
        } else {
          const addonToRemove = itemsContainer.querySelector(`.bundle-col-item[data-is-variant-addon="true"][data-product-id="${productId}"][data-variant-id="${cb.value}"]`);
          if (addonToRemove) addonToRemove.remove();
        }
      }

      this.calculateTotal();
    }
  }

  handleColItemAddClick(colItem, itemsContainer) {
    const productId = colItem.dataset.productId;
    const colContainer = itemsContainer.closest(".bundle-col-container");
    if (!colContainer) return;

    const colId = colContainer.dataset.colId;
    const collection = this.bundleCollections.find((c) => String(c.id) === String(colId));
    if (!collection || !collection.products) return; // Find the original product (primary item) from the collection
    const masterProd = collection.products.find((p) => String(p.id) === String(productId));
    if (!masterProd) return;

    // Clone product data and apply the current variant from colItem
    const currentVariantId = colItem.dataset.variantId;
    const productData = Object.assign({}, masterProd);

    if (currentVariantId && masterProd.variants && masterProd.variants.length > 1) {
      const matchedVariant = masterProd.variants.find((v) => String(v.id) === String(currentVariantId));
      if (matchedVariant) {
        productData.variantId = matchedVariant.id;
        productData.variantTitle = matchedVariant.title || "";
        productData.price = matchedVariant.price;
        productData.compareAtPrice = matchedVariant.compareAtPrice || 0;
        if (matchedVariant.image) productData.image = matchedVariant.image;
        if (matchedVariant.fullImage) productData.fullImage = matchedVariant.fullImage;
      }
    }

    this.addColItemToContainer(productData, itemsContainer);
  }

  openVariantPopupForAdd(colItem) {
    if (!this.variantPopup) {
      this.initVariantPopup();
    }

    const variantsData = colItem.querySelector(".bundle-variants-data");
    if (!variantsData) {
      return;
    }

    const checkboxes = Array.from(variantsData.querySelectorAll(".bundle-variant-checkbox"));
    if (!checkboxes.length) {
      return;
    }

    const grid = this.variantPopup.querySelector(".bundle-variant-popup__grid");
    grid.innerHTML = "";

    checkboxes.forEach((cb) => {
      const vTitle = cb.dataset.variantTitle || cb.dataset.title || "Variant";
      const vPrice = parseFloat(cb.dataset.price) || 0;
      const vImg = cb.dataset.image || "";
      const isDisabled = cb.disabled;

      const cell = document.createElement("div");
      cell.className = "bundle-variant-popup__item" + (isDisabled ? " is-disabled" : "");
      cell.innerHTML = `
        ${vImg ? `<img src="${vImg}" alt="${vTitle}" />` : `<div class="bundle-variant-popup__no-img"></div>`}
        <div class="bundle-variant-popup__item-title">${vTitle}</div>
        <div class="bundle-variant-popup__item-price">$${(vPrice / 100).toFixed(2)}</div>
        <div class="bundle-variant-popup__item-check">✓</div>
      `;

      if (!isDisabled) {
        cell.addEventListener("click", () => {
          if (this._addButtonContext) {
            const { masterProd, itemsContainer } = this._addButtonContext;

            // Create new product data with selected variant
            const newProductData = JSON.parse(JSON.stringify(masterProd));
            newProductData.variantId = cb.value;
            newProductData.variantTitle = cb.dataset.variantTitle || cb.dataset.title || "";
            newProductData.price = parseFloat(cb.dataset.price) || 0;
            newProductData.image = cb.dataset.image || masterProd.image;
            newProductData.fullImage = cb.dataset.fullImage || masterProd.fullImage || newProductData.image;

            // Add the new item
            this.addColItemToContainer(newProductData, itemsContainer);

            // Close popup
            this.closeVariantPopup();
            this._addButtonContext = null;
          }
        });
      }

      grid.appendChild(cell);
    });

    this.variantPopup.style.display = "flex";
  }
  addColItemToContainer(productData, itemsContainer) {
    if (!itemsContainer) return;

    // Ensure we're working with the actual col-items-container
    if (!itemsContainer.classList.contains("col-items-container")) {
      itemsContainer = itemsContainer.closest(".col-items-container") || itemsContainer;
    }

    const newItemHtml = this.renderColItemHTML(productData);
    const productId = productData.id;

    // Find or create the product group wrapper
    let productGroup = itemsContainer.querySelector(`.bundle-col-product-group[data-product-id="${productId}"]`);
    if (!productGroup) {
      const groupHtml = `<div class="bundle-col-product-group" data-product-id="${productId}"></div>`;
      itemsContainer.insertAdjacentHTML("afterbegin", groupHtml);
      productGroup = itemsContainer.firstElementChild;
    }

    productGroup.insertAdjacentHTML("afterbegin", newItemHtml);
    const newItem = productGroup.firstElementChild;
    // Attach events only to the new item, not the entire container
    if (newItem) {
      // Setup tooltip positioning for tooltips in new item
      const tooltips = newItem.querySelectorAll(".bundle-tooltip");
      tooltips.forEach((tooltip) => {
        this.attachTooltipPositioningListener(tooltip);
      });
    }

    this.calculateTotal();
  }

  syncCustomInputsToQty(colItem) {
    const inputDefs = this.getTextInputTypes(this.getColItemInputTypes(colItem));
    if (!inputDefs.length) return;

    const qtyInput = colItem.querySelector(".col-qty-input");
    const qty = parseInt(qtyInput ? qtyInput.value : 1) || 1;

    const inputWrapper = colItem.querySelector(".bundle-item__custom-input");
    if (!inputWrapper) return;

    const oldValues = {};
    const oldInputs = inputWrapper.querySelectorAll(".col-custom-property-input");
    oldInputs.forEach((input) => {
      oldValues[input.dataset.propertyName] = input.value;
    });

    const variantId = colItem.dataset.variantId || colItem.dataset.productId;

    // Re-render all inputs from scratch based on qty
    let html = "";
    for (let i = 0; i < qty; i++) {
      const labelSuffix = qty > 1 ? ` #${i + 1}` : "";
      inputDefs.forEach((inputDef, index) => {
        const inputLabel = inputDef.label || "Customize Your Stole";
        const isRequired = !!inputDef.required;
        const description = inputDef.description_optional || "";
        const placeholder = inputDef.placeholder || "";
        const propertyName = `${inputLabel}${labelSuffix}`;
        const tooltipHtml = description && description !== "null" ? `<div class="bundle-tooltip">?<div class="bundle-tooltip-text">${description}</div></div>` : "";
        const placeholderText = placeholder && placeholder !== "null" ? placeholder : `Enter ${inputLabel}...`;

        html += `
          <div class="bundle-col-custom-input-row">
            <label class="bundle-custom-input-label" for="col-custom-input-${variantId}-${i}-${index}">
              ${inputLabel}${labelSuffix}${isRequired ? ' <span style="color: red; margin-left: 2px;">*</span>' : ""}:
              ${tooltipHtml}
            </label>
            <input type="text"
              id="col-custom-input-${variantId}-${i}-${index}"
              class="bundle-custom-input custom-property-input col-custom-property-input"
              placeholder="${placeholderText}"
              data-property-name="${propertyName}"
              data-is-required="${isRequired}"
            />
            <div class="custom-property-error">${inputLabel} is required.</div>
          </div>
        `;
      });
    }
    inputWrapper.innerHTML = html;

    const newInputs = inputWrapper.querySelectorAll(".col-custom-property-input");
    newInputs.forEach((input) => {
      const previousValue = oldValues[input.dataset.propertyName];
      if (previousValue !== undefined) {
        input.value = previousValue;
      }
    });
  }

  findPrimaryItemByProductId(container, productId) {
    if (!container || !productId) return null;
    return container.querySelector(`.bundle-col-item[data-product-id="${productId}"]:not([data-is-variant-addon])`);
  }

  initVariantPopup() {
    if (this.variantPopup) {
      return;
    }

    const popup = document.createElement("div");
    popup.className = "bundle-variant-popup-overlay";
    popup.innerHTML = `
      <div class="bundle-variant-popup">
        <div class="bundle-variant-popup__header">
          <span class="bundle-variant-popup__title">Select Variant</span>
          <button type="button" class="bundle-variant-popup__close">&times;</button>
        </div>
        <div class="bundle-variant-popup__grid"></div>
        <div class="bundle-variant-popup__footer">
          <button type="button" class="bundle-variant-popup__ok">OK</button>
        </div>
      </div>
    `;

    popup.querySelector(".bundle-variant-popup__close").addEventListener("click", () => {
      this.closeVariantPopup();
    });
    popup.querySelector(".bundle-variant-popup__ok").addEventListener("click", () => {
      this.closeVariantPopup();
    });
    popup.addEventListener("click", (e) => {
      if (e.target === popup) {
        this.closeVariantPopup();
      }
    });

    document.body.appendChild(popup);
    this.variantPopup = popup;
  }

  closeVariantPopup() {
    if (this.variantPopup) {
      this.variantPopup.style.display = "none";
    }
    this._popupActiveItem = null;
  }

  openVariantPopup(item) {
    if (!this.variantPopup) {
      this.initVariantPopup();
    }

    const variantsData = item.querySelector(".bundle-variants-data");
    if (!variantsData) {
      return;
    }

    const checkboxes = Array.from(variantsData.querySelectorAll(".bundle-variant-checkbox"));
    if (!checkboxes.length) {
      return;
    }

    this._popupActiveItem = item;
    const grid = this.variantPopup.querySelector(".bundle-variant-popup__grid");
    grid.innerHTML = "";

    checkboxes.forEach((cb) => {
      const vTitle = cb.dataset.variantTitle || cb.dataset.title || "Variant";
      const vPrice = parseFloat(cb.dataset.price) || 0;
      const vImg = cb.dataset.image || "";
      const isChecked = cb.checked;
      const isDisabled = cb.disabled;

      const cell = document.createElement("div");
      cell.className = "bundle-variant-popup__item" + (isChecked ? " is-selected" : "") + (isDisabled ? " is-disabled" : "");
      cell.innerHTML = `
        ${vImg ? `<img src="${vImg}" alt="${vTitle}" />` : `<div class="bundle-variant-popup__no-img"></div>`}
        <div class="bundle-variant-popup__item-title">${vTitle}</div>
        <div class="bundle-variant-popup__item-price">$${(vPrice / 100).toFixed(2)}</div>
        <div class="bundle-variant-popup__item-check">✓</div>
      `;

      if (!isDisabled) {
        cell.addEventListener("click", () => {
          const canBeAdded = item.dataset.canBeAdded === "true";

          if (!canBeAdded) {
            checkboxes.forEach((c) => {
              c.checked = false;
            });
            cb.checked = true;
          } else {
            cb.checked = !cb.checked;
          }
          cb.dispatchEvent(new Event("change", { bubbles: true }));

          this.openVariantPopup(item);
        });
      }

      grid.appendChild(cell);
    });

    this.variantPopup.style.display = "flex";
  }
  handleVariantCheckboxChange(cb) {

    const colItem = cb.closest(".bundle-col-item");
    const itemsContainer = cb.closest(".col-items-container");
    const colWrapper = cb.closest(".bundle-col-container");

    if (!colItem || !itemsContainer) {
      return;
    }

    const isChecked = cb.checked;
    const canBeAdded = colItem.dataset.canBeAdded === "true";
    const productId = cb.dataset.productId;
    const variantsData = cb.closest(".bundle-variants-data");

    if (!variantsData) {
      return;
    }

    // If canBeAdded is false, allow only ONE variant to be selected at a time
    if (!canBeAdded && isChecked) {
      const allVariantCheckboxes = Array.from(variantsData.querySelectorAll(".bundle-variant-checkbox"));
      allVariantCheckboxes.forEach((checkbox) => {
        if (checkbox !== cb && checkbox.checked) {
          checkbox.checked = false;
        }
      });
    }

    const allChecked = Array.from(variantsData.querySelectorAll(".bundle-variant-checkbox:checked"));

    if (allChecked.length === 0) {
      // No variants selected — remove item via shared method
      this.removeColItem(colItem);
    } else {
      this.updateItemFromVariant(colItem, allChecked[0]);

      if (!canBeAdded) {
        const existingVariantAddons = itemsContainer.querySelectorAll(`.bundle-col-item[data-is-variant-addon="true"][data-product-id="${productId}"]`);
        existingVariantAddons.forEach((addon) => {
          addon.remove();
        });
      } else {
        if (isChecked) {
          const colId = colWrapper.dataset.colId;
          const collection = this.bundleCollections.find((c) => String(c.id) === String(colId));
          const masterProd = collection ? collection.products.find((p) => String(p.id) === String(productId)) : null;

          const fakeProd = {
            id: cb.dataset.productId,
            variantId: cb.value,
            price: cb.dataset.price,
            compareAtPrice: cb.dataset.compare,
            title: cb.dataset.title,
            image: cb.dataset.image,
            fullImage: cb.dataset.fullImage,
            url: cb.dataset.url || "#",
            variantTitle: cb.dataset.variantTitle,
            inputType: colItem.dataset.inputType || "",
            inputLabel: colItem.dataset.inputLabel || "",
            isRequired: colItem.dataset.isRequired === "true",
            description: colItem.dataset.description || "",
            placeholder: colItem.dataset.placeholder || "",
            variants: masterProd ? masterProd.variants : null,
            canBeAdded: canBeAdded,
          };

          const productGroup = itemsContainer.querySelector(`.bundle-col-product-group[data-product-id="${productId}"]`);
          const insertTarget = productGroup || colItem.parentElement;

          const newItemHtml = this.renderColItemHTML(fakeProd);

          insertTarget.insertAdjacentHTML("afterbegin", newItemHtml);

          const newAddon = insertTarget.firstElementChild;

          newAddon.dataset.isVariantAddon = "true";
          newAddon.dataset.productId = colItem.dataset.productId;

          // Setup tooltip positioning for new addon
          const tooltips = newAddon.querySelectorAll(".bundle-tooltip");
          tooltips.forEach((tooltip) => {
            this.attachTooltipPositioningListener(tooltip);
          });

          // Attach direct listeners to checkboxes of new addon
          const newCheckboxes = newAddon.querySelectorAll(".bundle-variant-checkbox");
          newCheckboxes.forEach((checkbox) => {
            this.bindColVariantCheckbox(checkbox);
          });
        } else {
          const addonToRemove = itemsContainer.querySelector(`.bundle-col-item[data-is-variant-addon="true"][data-product-id="${productId}"][data-variant-id="${cb.value}"]`);
          if (addonToRemove) {
            addonToRemove.remove();
          }
        }
      }

      this.calculateTotal();
    }
  }
}

if (!customElements.get("products-bundle-custom")) {
  customElements.define("products-bundle-custom", ProductsBundleCustom);
}
